import { makeStyles } from '@ellucian/react-design-system/core';
import { spacing40 } from '@ellucian/react-design-system/core/styles/tokens';
import { Typography } from '@ellucian/react-design-system/core';
import HtmlFormattedMessage from '../HtmlFormattedMessage/HtmlFormattedMessage';

const useStyles = makeStyles({
    name: 'Footer'
})(() => ({
    copyright: {
        textAlign: 'center',
        overflowWrap: 'break-word',
        wordBreak: 'break-word', 
    },
    root: {
        paddingTop: spacing40,
        backgroundColor: 'transparent !important',
        '& *': {
            backgroundColor: 'transparent !important'
        }
    },

    privacyPolicy: {
        textAlign: 'center',
        marginBottom: spacing40,
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
    }

}));

const Footer = () => {
    const { classes } = useStyles();
    return (
        <div className={classes.root} role="contentinfo">
            <Typography className={classes.copyright}>
                <HtmlFormattedMessage descriptor={{ id: 'footerText' }} normalizeSpaces />
            </Typography>
                
            <div className={classes.privacyPolicy}>
                <Typography>
                    <HtmlFormattedMessage descriptor={{ id: 'privacyPolicy' }} normalizeSpaces />
                </Typography>
            </div>
        </div>
    );
};

export default Footer;